import { Typography, Stack, Button, Box } from '@mui/material';
import Icon from '@/units/Icon';

export const NoNotesFound = ({ handleAddThread, isCompleted, setFilterState, isGuest }) => {
  return (
    <Stack sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingX: '66px' }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '42px',
          height: '42px',
          backgroundColor: '#F2F4F7',
          border: '6px solid #F9FAFB',
          borderRadius: '50%',
          padding: '7px',
          textAlign: 'center',
          mb: '16px',
        }}
      >
        <Icon.Search sx={{ fontSize: '22px', color: '#2055FF' }} />
      </Box>
      <Typography
        sx={{
          font: 'Inter',
          fontSize: '16px',
          fontWeight: '600',
          lineHeight: '24px',
          color: '#101828',
          mb: '4px',
        }}
      >
        No results found
      </Typography>
      <Typography
        sx={{
          font: 'Inter',
          fontSize: '14px',
          fontWeight: '400',
          lineHeight: '20px',
          color: '#667085',
          mb: '24px',
        }}
      >
        {isCompleted ? `Click “reset the filter” to see the list again.` : `Click “Add Note” to create your first note.`}
      </Typography>
      {isCompleted ? (
        <Button
          startIcon={<i className="fa-solid fa-arrow-rotate-left" style={{ color: '#101828' }} />}
          onClick={() => setFilterState('all')}
          sx={{
            background: 'white',
            border: '1px solid #EAECF0',
            borderRadius: '8px',
            paddingX: '52px',
            paddingY: '10px',
            '&:hover': {
              background: 'white',
              border: '1px solid #2055FF',
            },
          }}
        >
          <Typography sx={{ color: '#101828', fontWeight: '600', fontSize: '16px' }}>Reset the filter</Typography>
        </Button>
      ) : (
        <Button
          startIcon={<i className="fa-regular fa-plus" />}
          disabled={isGuest}
          onClick={handleAddThread}
          sx={{
            background: '#2055FF',
            borderRadius: '8px',
            paddingX: '52px',
            paddingY: '10px',
            '&:hover': {
              background: '#2055FF',
            },
          }}
        >
          Add Note
        </Button>
      )}
    </Stack>
  );
};
